
export function meanByIndex(matrix) {
    const rows = matrix.length;

    const sums = matrix.reduce((acc, row) => acc.map((value, i) => value + row[i])
    );

    return sums.map(s => s / rows);
}


export function getSurvivingHourlyIntervals(timestamps, selectedHoursOfDay, selectedDaysOfWeek) {

    const survivingIndices = [];

    timestamps.forEach((timestamp, index) => {
        const datetime = new Date(timestamp);
        const hourOfDay = datetime.getHours();
        const dayOfWeek = datetime.getDay();
        const shouldKeepIndex = selectedHoursOfDay.includes(hourOfDay) && selectedDaysOfWeek.includes(dayOfWeek);
        if (shouldKeepIndex) {
            survivingIndices.push(index);
        }
    });

    return survivingIndices;

}

export function filterDataToSurvivingIndices(pointsData, survivingIndices) {
    return pointsData.map((pointData) => ({
        ...pointData,
        values: survivingIndices.map((index) => pointData.values[index])
    }));
}

// data is the of the format 
// { timestamps: ["timestamp1", "timestamp2", ...], points_data: [{values: [val1, val2, ...], metadata: {...}}, ...]}
// timeAggType is "h", "d", "m", "q", or "y"
export function filterDataToSelectedIntervals(data, selectedHoursOfDay, selectedDaysOfWeek) {

    const survivingIndices = getSurvivingHourlyIntervals(data.timestamps, selectedHoursOfDay, selectedDaysOfWeek);
    const filteredTimestamps = survivingIndices.map((index) => data.timestamps[index]);
    const filteredPointsData = filterDataToSurvivingIndices(data.points_data, survivingIndices) ?? [];

    return {
        timestamps: filteredTimestamps, points_data: filteredPointsData
    }
}


export function filterInBasedOnSystemAndLocation(occupancyData, includedSystems, includedLocations) {
    if (includedSystems.length === 0 && includedLocations.length === 0) {
        return occupancyData;
    }
    return Object.fromEntries(
        Object.entries(occupancyData).map(([key, entry]) => {
            const points_data = (entry.points_data || [])
                .map((pointData) => {
                    const systemMatches = includedSystems.length === 0 || includedSystems.includes(pointData.metadata.system);
                    const locationMatches = includedLocations.length === 0 || includedLocations.includes(pointData.metadata.location);
                    return systemMatches && locationMatches ? pointData : null;
                })
                .filter(Boolean);
            return [key, { ...entry, points_data }];
        })
    );
}